module.exports = __webpack_public_path__ + "media/images/diy/Uplight-cyan-I-Do-setting-with-in-ah-house-bbf9b0ea56af87fd371cf183458bf433.jpg";